export const AccountIcon = () => {
  return (
    <svg fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='1'>
        <path
          d='M5.77441 11.793C8.11606 10.243 11.9074 10.243 14.2324 11.793C15.2824 12.493 15.8579 13.4428 15.8662 14.4678C15.8661 15.501 15.2824 16.4509 14.2324 17.1592C13.0658 17.9424 11.5323 18.334 9.99902 18.334C8.46596 18.3339 6.93313 17.9423 5.7666 17.1592C4.71665 16.4592 4.13287 15.5093 4.13281 14.4844C4.13281 13.4594 4.71623 12.5013 5.77441 11.793ZM9.99902 1.66797C12.1824 1.66797 13.958 3.44264 13.958 5.62598C13.9497 7.76762 12.2739 9.50117 10.1406 9.57617H10.083C10.033 9.56784 9.96607 9.56784 9.89941 9.57617C7.71609 9.50117 6.04104 7.76762 6.04102 5.62598C6.04102 3.44275 7.81584 1.66815 9.99902 1.66797Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
